<header
  class="dialog-header"
  cdkDrag
  cdkDragHandle
  cdkDragRootElement=".cdk-overlay-pane"
  [cdkDragDisabled]="fullscreen()"
>
  <h2 [id]="data.titleId">{{ title() || "Gráficos" }}</h2>
  <button type="button" class="icon-btn" aria-label="Fechar janela" appTooltip="Fechar janela" (click)="close()">
    <svg-icon src="assets/mdi/close.svg" aria-hidden="true" />
  </button>
</header>

<div #content class="renderer-content">
  <canvas #canvas width="640" height="480"></canvas>
</div>
